
  import {Component, Vue, Watch} from "vue-property-decorator";
  import editConfig from "./editConfig";
  import {parseTime} from "@/utils";

  @Component({
    name: "FindNoTransCodeStatus"
  })
  export default class extends Vue {
    private config = editConfig;

    private created(): void {
    }

    private mounted(): void {
    }

    public countVo = {"nSumNoTranNum": "0", "nSumAlreadyTranNum": "0", "nSumRepeadTranNum": "0", "nSumUploadFail": "0"};

    private vo: FindNoTransCodeStatusVo = {packgeCode: "", opCode: "", dateRange: []};

    private searchClick() {
      var result = obj_findNoTransCodeStatus.buttonSearch_Click(this.vo.opCode, parseTime(this.vo.dateRange[0], '{y}-{m}-{d} 00:00:00'),
        parseTime(this.vo.dateRange[1], '{y}-{m}-{d} 23:59:59'));
      this.countVo = JSON.parse(result);
      this.$message.success('查询完成')
    }

    private errorMsg: string = '';

    private keypress() {
      if (this.vo.packgeCode.trim()) {
        var result = obj_findNoTransCodeStatus.noTranCodeSearch_KeyPress(this.vo.packgeCode.toUpperCase().trim());
        this.errorMsg = result;
        this.$message.success('查询完成')
      }
    }

    private pickerOptions = {
      shortcuts: [{
        text: '最近一周',
        onClick(picker) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
          picker.$emit('pick', [start, end]);
        }
      }, {
        text: '最近一个月',
        onClick(picker) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
          picker.$emit('pick', [start, end]);
        }
      }, {
        text: '最近三个月',
        onClick(picker) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
          picker.$emit('pick', [start, end]);
        }
      }
      ]
    }
  }
